import script from "./Accordian.vue?vue&type=script&setup=true&lang=ts"
export * from "./Accordian.vue?vue&type=script&setup=true&lang=ts"

import "./Accordian.vue?vue&type=style&index=0&id=23e45e14&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23e45e14"]])

export default __exports__